import { render } from "./NomenclatureTypesView.vue?vue&type=template&id=0ca6a9f3&scoped=true"
import script from "./NomenclatureTypesView.vue?vue&type=script&lang=js"
export * from "./NomenclatureTypesView.vue?vue&type=script&lang=js"

import "./NomenclatureTypesView.vue?vue&type=style&index=0&id=0ca6a9f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca6a9f3"]])

export default __exports__